import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import SnackbarInfo from '../common/snackbar-info.component';
import Iconify from '../common/iconify.component';
import {
  getListSequence,
  updateChannelShowVideosSequence,
} from '../../services/content.service';
import {
  CONTENT_ALIAS,
  DEFAULT_CHANNEL_VALUE,
} from '../../config/const.config';
import Loading from '../table-elements/loading.component';

const ListSequenceVideos = ({ title, dataId, onCancel, onSuccess }) => {
  const { handleSubmit } = useForm({});
  const [videoList, setVideoList] = useState([]);
  const [catOptions, setCatOptions] = useState({
    error: false,
    loading: true,
    channelIDError: false,
  });
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });
  let channel;

  const handleOnDragEndVideos = (result) => {
    if (result.destination) {
      const newVideos = Array.from(videoList);
      const [draggedItem] = newVideos.splice(result.source.index, 1);
      newVideos.splice(result.destination.index, 0, draggedItem);
      setVideoList(newVideos);
    }
  };

  const handleUpdateVideoSequence = () => {
    setSnackbarInfo({
      ...snackbarInfo,
      show: false,
    });

    const updatedVideoSequence = videoList.map((video) => video.id);

    const payload = {
      // channelID: videoList[0].channel_id,
      showID: dataId,
      newSequence: updatedVideoSequence,
    };

    updateChannelShowVideosSequence(payload)
      .then((res) => {
        if (res?.data?.success) {
          onSuccess(
            `${CONTENT_ALIAS.VIDEO_PLURAL} sequence updated successfully.`
          );
        }
      })
      .catch(() => {
        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'error',
          message: 'Something went wrong.',
        });
      });
  };

  const onFormSubmit = () => {
    // setFormSubmitted(true);
    setSnackbarInfo({
      ...snackbarInfo,
      show: false,
    });

    if (dataId) {
      handleUpdateVideoSequence();
    }
  };

  const getSequenceData = () => {
    let uri = 'video-show';
    uri += `?channelID=${channel}`;
    uri += `&showID=${dataId}`;

    getListSequence(uri)
      .then((res) => {
        setCatOptions({
          ...catOptions,
          loading: false,
          error: false,
        });
        setVideoList(res.data);
      })
      .catch(() => {
        setCatOptions({
          ...catOptions,
          loading: false,
          error: true,
        });
        setVideoList([]);
      });
  };

  useEffect(() => {
    // TODO:
    // Currently assume that channelID is not received
    // Add logic to handle checking channelID from database and its execution

    if (DEFAULT_CHANNEL_VALUE) {
      channel = DEFAULT_CHANNEL_VALUE;
      // setChannelID(DEFAULT_CHANNEL_VALUE);
      setCatOptions({ ...catOptions, channelIDError: false });
    } else {
      setCatOptions({ ...catOptions, channelIDError: true });
    }

    getSequenceData();
  }, []);

  return (
    <Dialog
      open
      onClose={() => onCancel()}
      aria-labelledby="add-dialog-title"
      aria-describedby="add-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="view-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="add-dialog-description">
        {catOptions.loading && <Loading />}

        {catOptions.channelIDError && <Paper>Something went wrong.</Paper>}

        {!catOptions.channelIDError && (
          <form id="manage-seq-form" onSubmit={handleSubmit(onFormSubmit)}>
            {/* <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ px: 3, paddingBottom: 2 }}
            > */}
            {/* <div>&nbsp;</div>
              <div>
                <Button
                  color="primary"
                  variant="contained"
                  startIcon={<Iconify icon="prime:save" />}
                  onClick={() => handleUpdateVideoSequence()}
                  disabled={videoList.length === 0 || videoList.length === 1}
                >
                  Save
                </Button>
              </div> */}
            {/* </Stack> */}

            <Container
            // maxWidth="false"
            // sx={{ maxHeight: '74vh', overflowY: 'auto', paddingX: 0 }}
            >
              <DragDropContext onDragEnd={handleOnDragEndVideos}>
                <Droppable droppableId="videos" isDropDisabled={false}>
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {!catOptions.loading &&
                        videoList.length > 0 &&
                        videoList.map((video, index) => (
                          <Draggable
                            key={`video-${video.id}`}
                            draggableId={video.id.toString()}
                            index={index}
                          >
                            {(provide) => (
                              <Card
                                sx={{
                                  marginBottom: '5px',
                                }}
                                ref={provide.innerRef}
                                {...provide.draggableProps}
                                {...provide.dragHandleProps}
                              >
                                <CardContent
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    paddingY: '12px',
                                    '&:last-child': {
                                      paddingBottom: '12px',
                                    },
                                  }}
                                >
                                  <div>{video.title}</div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {/* <Button
                                    style={{
                                      marginLeft: 10,
                                      marginRight: 10,
                                    }}
                                    color="inherit"
                                    onClick={() =>
                                      handleShowReordering(category)
                                    }
                                  >
                                    {`Reorder ${CONTENT_ALIAS.SHOW_PLURAL} Sequence`}
                                  </Button> */}
                                    <Iconify icon="ic:round-table-rows" />
                                  </div>
                                </CardContent>
                              </Card>
                            )}
                          </Draggable>
                        ))}

                      {!catOptions.loading && videoList.length === 0 && (
                        <Paper
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '10vh',
                          }}
                        >
                          No data available.
                        </Paper>
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </Container>
          </form>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'left', marginLeft: 2 }}>
        <Button
          type="submit"
          form="manage-seq-form"
          color="primary"
          variant="contained"
          disabled={videoList.length === 0 || videoList.length === 1}
        >
          Save
        </Button>
        <Button
          color="secondary"
          variant="contained"
          onClick={onCancel}
          // disabled={formSubmitted}
        >
          Cancel
        </Button>
      </DialogActions>

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </Dialog>
  );
};

ListSequenceVideos.propTypes = {
  title: PropTypes.string.isRequired,
  dataId: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default ListSequenceVideos;
